<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M22 7l-8.5 8.5-5-5L2 17M16 7h6v6"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
